import { render, staticRenderFns } from "./ChatOffline.vue?vue&type=template&id=62c07554&"
import script from "./ChatOffline.vue?vue&type=script&lang=js&"
export * from "./ChatOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports